import { isHobbyPlan } from './plan-utils';

export function hasOrgSubscriptionHistory({
  hasLegacyEntitlement,
  hasLegacySubscriptionId,
  hasLegacyCustomerId,
  hasBeenOnStripeSystem,
  hasCurrentEntitlements,
  hasPastPaidSubscription,
}: {
  hasLegacyEntitlement: boolean;
  hasLegacySubscriptionId: boolean;
  hasLegacyCustomerId: boolean;
  hasBeenOnStripeSystem: boolean;
  hasCurrentEntitlements: boolean;
  hasPastPaidSubscription: boolean;
}): boolean {
  if (hasPastPaidSubscription) {
    return true;
  }

  if (hasLegacyEntitlement || hasLegacySubscriptionId || hasLegacyCustomerId) {
    return true;
  }

  return hasBeenOnStripeSystem && !hasCurrentEntitlements;
}

export function canStartPlanTrial({
  canTrial,
  hasTrialed,
  hasSubscribedBefore,
  currentPlanId,
  targetPlanId,
}: {
  canTrial: boolean;
  hasTrialed: boolean;
  hasSubscribedBefore: boolean;
  currentPlanId?: string;
  targetPlanId: string;
}): boolean {
  if (!canTrial || hasTrialed || hasSubscribedBefore) {
    return false;
  }

  // Trials are only for first-time paid plan checkout, not hobby, and not while already on a paid plan.
  // A free Hobby org can still start a trial for a paid plan.
  if ((currentPlanId && !isHobbyPlan(currentPlanId)) || isHobbyPlan(targetPlanId)) {
    return false;
  }

  return true;
}

export function shouldRecordPastPaidSubscription({
  internalPlanId,
  subscriptionStatus,
}: {
  internalPlanId: string;
  subscriptionStatus: string;
}): boolean {
  return !isHobbyPlan(internalPlanId) && subscriptionStatus === 'active';
}
